import { apiGateway } from '../api';

async function getEstadoCivil() {
    try {
        const response = await apiGateway.get('/estadoscivis');
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getBanco() {
    try {
        const response = await apiGateway.get('/bancos');
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getSituacaoEmpresa() {
    try {
        const response = await apiGateway.get('/situacoesempresa');
        return response.data;
    } catch (error) {
        // console.error(error);
        return error;
    }
}

async function getCids(offset = 0, limit = 10) {
    try {
        const response = await apiGateway.get(`/cids?offset=${offset}&limit=${limit}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export { getEstadoCivil, getBanco, getSituacaoEmpresa, getCids };
